import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Logo } from "../logo/Logo";
import classes from "./Header.module.scss";

export const Header = ({ children }) => {
  return (
    <header className={classes["header"]}>
      <Link to={"/"}>
        <Logo />
      </Link>
      <div>{children}</div>
    </header>
  );
};

Header.propTypes = {
  /**
   * Children to be shown on the left side of header
   */
  children: PropTypes.node,
};

Header.defaultProps = {
  children: undefined,
};
